import { Step2ValueModel, Step3ValueModel } from './types'
import {
    validateAccountType,
    validateBg,
    validatePg,
    validateStreetBox,
    validateZipCode,
    validateCity,
    validateMunicipality,
    validateVisitingAddressStreetAddress,
    validateVisitingAddressZipCode,
    validateVisitingAddressCity,
    validatePostalAddressStreetBox,
    validatePostalAddressZipCode,
    validatePostalAddressCity,
    validateDeliveryAddressZipCode,
    validateDeliveryAddressCity,
    validateVat,
} from '../shared/Validation'
import { AccountType } from '../shared/types'
import { validateDeliveryAddressStreetAddress } from '../shared/Validation'
import { FormErrorType } from "@sharedComponents/PantaForm/types";
import { validateRequired } from "@sharedComponents/PantaForm/utils";
import i18n from "@apps/Shared/translation/i18n";

export const validateAssociationName = (
    associationName: string | undefined,
    currentErrors: FormErrorType[]
) => {
    const errors = validateRequired(
        associationName,
        'associationName',
        i18n.t('error.emptyAssociationName'),
        currentErrors
    )

    return errors
}

export const validateTeamName = (
    teamName: string | undefined,
    currentErrors: FormErrorType[]
) => {
    const errors = validateRequired(
        teamName,
        'teamName',
        i18n.t('error.emptyTeamName'),
        currentErrors
    )

    return errors
}

export const validateDepositAlternative = (
    depositAlternative: string,
    currentErrors: FormErrorType[]
) => {
    const errors = validateRequired(
        depositAlternative,
        'depositAlternative',
        i18n.t('error.emptyDepositAlternative'),
        currentErrors
    )

    return errors
}

export const validateStep2 = async (
    stepValues: Step2ValueModel,
    currentErrors: FormErrorType[]
) => {
    let errors = [...currentErrors]

    errors = validateAssociationName(stepValues.associationName, errors)
    if (stepValues.registeredForVAT === 'true') {
        errors = validateVat(stepValues.vatNumber, errors)
    }
    errors = validateAccountType(stepValues.accountType, true, errors)
    errors = validateBg(
        stepValues.bg,
        stepValues.accountType === AccountType.Bg,
        errors
    )
    errors = validatePg(
        stepValues.pg,
        stepValues.accountType === AccountType.Pg,
        errors
    )
    errors = validateStreetBox(stepValues.streetBox, errors)
    errors = validateZipCode(stepValues.zipCode, true, errors)
    errors = validateCity(stepValues.city, errors)

    return errors
}

export const validateStep3 = async (
    stepValues: Step3ValueModel,
    currentErrors: FormErrorType[]
) => {
    let errors = [...currentErrors]

    errors = validateTeamName(stepValues.teamName, errors)
    errors = validateMunicipality(stepValues.municipality, errors)
    errors = validateDepositAlternative(stepValues.depositAlternative, errors)
    errors = validateVisitingAddressStreetAddress(
        stepValues.visitingAddress.streetAddress,
        errors
    )
    errors = validateVisitingAddressZipCode(
        stepValues.visitingAddress.zipCode,
        true,
        errors
    )
    errors = validateVisitingAddressCity(
        stepValues.visitingAddress.city,
        errors
    )
    errors = validatePostalAddressStreetBox(
        stepValues.postalAddress.streetBox,
        stepValues.visitingAddress.isAlsoPostalAddress !== true,
        errors
    )
    errors = validatePostalAddressZipCode(
        stepValues.postalAddress.zipCode,
        stepValues.visitingAddress.isAlsoPostalAddress !== true,
        true,
        errors
    )
    errors = validatePostalAddressCity(
        stepValues.postalAddress.city,
        stepValues.visitingAddress.isAlsoPostalAddress !== true,
        errors
    )
    errors = validateDeliveryAddressStreetAddress(
        stepValues.deliveryAddress?.streetAddress,
        stepValues.visitingAddress.isAlsoPostalAddress !== true,
        errors
    )
    errors = validateDeliveryAddressZipCode(
        stepValues.deliveryAddress?.zipCode,
        stepValues.visitingAddress.isAlsoPostalAddress !== true,
        true,
        errors
    )
    errors = validateDeliveryAddressCity(
        stepValues.deliveryAddress?.city,
        stepValues.visitingAddress.isAlsoPostalAddress !== true,
        errors
    )

    return errors
}